export const POSTING = "Posting";
export const COMPLETED = "Completed";
export const FAILED = "Failed";
export const DISCARDING = "Discarding";
export const DISCARD_FAILED = "DiscardFailed";
export const DISCARDED = "Discarded";
